module.exports = __webpack_public_path__ + "static/media/img-01.7b4031ba.jpg";